export const POLLING_INTERVAL_IN_MS: number = 10000;// 10 seconds
export const MAX_RETRIES = 15;
